
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Pencil } from "lucide-react";
import { useState } from "react";
import { PlanForm } from "./PlanForm";

interface Plan {
  id: string;
  feature_id: string;
  name: string;
  price: number;
  duration: number;
  type: string;
  status: string;
}

interface EditPlanDialogProps {
  plan: Plan;
  onPlanUpdated: () => void;
}

export const EditPlanDialog = ({ plan, onPlanUpdated }: EditPlanDialogProps) => {
  const [open, setOpen] = useState(false);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="ghost" size="icon" className="text-primary hover:text-primary/80">
          <Pencil className="h-4 w-4" />
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Edit Plan</DialogTitle>
        </DialogHeader>
        <PlanForm
          initialValues={{
            id: plan.id,
            feature_id: plan.feature_id,
            name: plan.name,
            price: plan.price,
            duration: plan.duration,
            type: plan.type,
            status: plan.status,
          }}
          mode="edit"
          onSuccess={() => {
            setOpen(false);
            onPlanUpdated();
          }}
        />
      </DialogContent>
    </Dialog>
  );
};
